export const dateTime24Options = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

export const formatDateTime24 = (value, locale) => {
  if (!value) return '';
  return new Date(value).toLocaleString(locale || undefined, dateTime24Options);
};
